
namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SortingDialog extends _Ext.TransDialog<SortingRow, any> {
        protected getFormKey() { return SortingForm.formKey; }
        protected getIdProperty() { return SortingRow.idProperty; }
        protected getLocalTextPrefix() { return SortingRow.localTextPrefix; }
        protected getNameProperty() { return SortingRow.nameProperty; }
        protected getService() { return SortingService.baseUrl; }
        protected getDeletePermission() { return SortingRow.deletePermission; }
        protected getInsertPermission() { return SortingRow.insertPermission; }
        protected getUpdatePermission() { return SortingRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new SortingForm(this.idPrefix);
        public Closing: boolean;
        public AtbId: number;

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.Details, Config);
            q.hideEditorLabel(this.form.Details);
            q.hideEditorLabel(this.form.DetailItems);
            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.Details);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.NewPieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NewWeight);
            q.setTextRightAlign(this.form.Rate);

            var fieldEditor: JQuery = this.form.NewProductId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.selectStockLotNo(e) }
                );

            this.form.ProductTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.checkAttribute();
            })
            this.form.SubCategoryId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.QualityId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.SieveId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.StoneSizeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.StoneColorId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.NewPieces.changeSelect2(e => {
                var weight = this.form.Weight.value;
                var pieces = this.form.Pieces.value;
                var newpieces = this.form.NewPieces.value;
                this.form.NewWeight.value = (weight / pieces) * newpieces;
            });
            this.form.NewWeight.changeSelect2(e => {
                var weight = this.form.Weight.value;
                var pieces = this.form.Pieces.value;
                var newpieces = this.form.NewPieces.value;
                var newweight = this.form.NewWeight.value;
                if (pieces == newpieces && weight != newweight) {
                    q.alert('', 'All Pieces and Weight need to be consumed', true, 2999);
                    this.form.NewPieces.value = 0;
                    this.form.NewWeight.value = 0;
                    return;
                }
            })
            this.form.GenerateLot.onClick = (e) => {

                if (this.form.NewWeight.value == 0 || this.form.NewWeight.value == undefined || this.form.NewPieces.value == 0 || this.form.NewPieces.value == undefined) {
                    Q.alert('New Pieces and Weight value cannot be 0')
                    return;
                }
                if (this.form.NewWeight.value > 0) {
                    if (this.form.NewPieces.value == 0 || this.form.NewPieces.value == undefined) {
                        Q.alert('New Pieces should be added first');
                        this.form.NewWeight.value = 0;
                        return;
                    }
                }
                let product = (this.form.Details.getItems()[0]);
                var baseitemid = this.form.ProductTypeId.value == undefined ? 0 : this.form.ProductTypeId.value;
                var itemtypeid = product.ItemTypeId;
                var typeid = this.form.CategoryId.value == undefined ? 0 : this.form.CategoryId.value;
                var subtypeid = this.form.SubCategoryId.value == undefined ? 0 : this.form.SubCategoryId.value;
                var qualityid = this.form.QualityId.value == undefined ? 0 : this.form.QualityId.value;
                var sieveid = this.form.SieveId.value == undefined ? 0 : this.form.SieveId.value;
                var StoneSizeId = this.form.StoneSizeId.value == undefined ? 0 : this.form.StoneSizeId.value;
                var stonecolorid = this.form.StoneColorId.value == undefined ? 0 : this.form.StoneColorId.value;
                var newproductid = this.form.NewProductId.value;
                if (baseitemid == null || newproductid == "" || newproductid == null || typeid == "" || subtypeid == ""
                    || qualityid == "" || sieveid == null || StoneSizeId == "" || stonecolorid == "") {
                    Q.alert('All Attributes need to be selected');
                    this.form.NewPieces.value = 0;
                    return;
                }

                var detailentity = this.form.Details.getItems()[0];
                detailentity.ProductId = parseInt(newproductid.toString());
                detailentity.ProductTypeId = parseInt(baseitemid.toString());
                detailentity.CategoryId = parseInt(typeid.toString());
                detailentity.SubCategoryId = parseInt(subtypeid.toString());
                detailentity.SieveId = parseInt(sieveid.toString());
                detailentity.StoneSizeId = parseInt(StoneSizeId.toString());
                detailentity.StoneColorId = parseInt(stonecolorid.toString());
                detailentity.QualityId = parseInt(qualityid.toString());
                detailentity.ItemTypeId = parseInt(itemtypeid.toString());
                //Category=parseInt(typeid.toString()),
                //SubCategoryId=parseInt(subtypeid.toString());
                detailentity.SieveName = this.form.SieveId.selectedItem.AttributeName;
                detailentity.StoneSizeName = this.form.StoneSizeId.selectedItem.AttributeName;
                detailentity.StoneColoreName = this.form.StoneColorId.selectedItem.AttributeName;
                detailentity.QualityName = this.form.QualityId.selectedItem.AttributeName;
                detailentity.ShapeName = this.form.ShapeId.selectedItem.AttributeName;
                detailentity.UnitRate = this.form.Rate.value;

                var lotno = this.form.LotNo.value;
                var newatbid = lotno == "" ? 0 : this.AtbId;
                if (this.form.DetailItems.getItems().length > 0) {
                    var Items = [];
                    var newitems = this.form.DetailItems.getItems();


                    var newpcs = 0; var newwt = 0;
                    for (var i = 0; i < newitems.length; i++) {
                        newpcs += newitems[i].Pieces;
                        newwt += newitems[i].Weight;
                    }
                    var pcs = this.form.Pieces.value - newpcs;
                    var wt = this.form.Weight.value - newwt;
                    if (pcs >= this.form.NewPieces.value && wt >= this.form.NewWeight.value)
                        this.form.DetailItems.setData(detailentity, newatbid, this.form.NewPieces.value,
                            this.form.NewWeight.value, parseInt(this.form.NewProductId.value), lotno);

                    else
                        Q.notifyError('Invalid Value(New Pieces/New Weight) should be less than Pieces/Weight');


                } else {
                    if (this.form.NewPieces.value <= this.form.Pieces.value && this.form.NewWeight.value <= this.form.Weight.value)
                        this.form.DetailItems.setData(detailentity, newatbid, this.form.NewPieces.value,
                            this.form.NewWeight.value, parseInt(this.form.NewProductId.value), lotno);
                    else
                        Q.notifyError('Invalid Value(New Pieces/New Weight) should be less than Pieces/Weight');
                }
                this.form.NewPieces.element.focus;

            }
            this.form.Clear.onClick = (e) => {
                var T = this.isViewMode();

                if (!this.isViewMode()) {
                    this.form.ProductTypeId.value = 0;
                    this.form.CategoryId.value = "0";
                    this.form.SubCategoryId.value = "0";
                    this.form.StoneColorId.value = "0";
                    this.form.StoneSizeId.value = "0";
                    this.form.SieveId.value = "0";
                    this.form.QualityId.value = "0";
                    this.form.ShapeId.value = "0";
                    this.form.NewPieces.value = 0;
                    this.form.NewWeight.value = 0;
                    this.form.LotNo.value = "";

                    this.setAttributeReadOnly(false);
                }
            }
        }
        checkAttribute() {
            var baseitemid = (this.form.ProductTypeId.value) == undefined ? 0 : (this.form.ProductTypeId.value);
            var typeid = parseInt(this.form.CategoryId.value) == undefined ? 0 : parseInt(this.form.CategoryId.value);
            var subtypeid = parseInt(this.form.SubCategoryId.value) == undefined ? 0 : parseInt(this.form.SubCategoryId.value);
            var qualityid = parseInt(this.form.QualityId.value) == undefined ? 0 : parseInt(this.form.QualityId.value);
            var sieveid = parseInt(this.form.SieveId.value) == undefined ? 0 : parseInt(this.form.SieveId.value);
            var StoneSizeId = parseInt(this.form.StoneSizeId.value) == undefined ? 0 : parseInt(this.form.StoneSizeId.value);
            var stonecolorid = parseInt(this.form.StoneColorId.value) == undefined ? 0 : parseInt(this.form.StoneColorId.value);

            var attributeid;
            OMS.CommonAttributesService.GetProductATB({

                ProductTypeId: baseitemid,
                CategoryId: typeid,
                SubCategoryId: subtypeid,
                QualityId: qualityid,
                SieveId: sieveid,
                StoneSizeId: StoneSizeId,
                StoneColorId: stonecolorid
            }, response => {
                attributeid = response.AttributeId
            }, { async: false }
            );
            if (attributeid.length > 0) {
                this.AtbId = attributeid[0].AttributeId;
            }
            else {
                this.AtbId = 0;
            }

        }

        protected selectStockLotNo(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = Common.StockSelectGrid;
                var filters: _Ext.SelectGridFilters = {
                    FilterItems: 7
                }
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: true, title: "Select Items",
                    GridFilters: filters
                });


                pickerDialog.onSuccess = (selectedItems: any[]) => {
                    let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.form.DetailItems.getItems(), n => n.ProductId == t.ProductId) });
                    //alert('Length' + selectedItems.length);
                    if (selectedItems2.length > 1) {
                        q.alert('', 'Only one item can be selected', true, 2999);
                        return;
                    }
                    if (selectedItems2[0].LotNo == this.form.LotNo.value) {
                        q.alert('', 'Same Lot No cannot be Selected', true, 2999);
                        return;
                    }
                    // #region Items to Grid
                    //for (let value of selectedItems2)
                    var value = selectedItems2[0];
                    this.AtbId = value.AttributeId;
                    this.setAttributes(value, false);
                    this.setAttributeReadOnly(true);

                }
                // #endregion

                pickerDialog.dialogOpen();
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Inventory:Sorting:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    SortingService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });



            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                Stock.StockItemService.CheckTransaction(
                    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            refid = response.Entities[0];
                    }, { async: false }
                )
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                    this.form.Details.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        SortingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        } 
        public setAttributes(item: SortingDetailsRow, createlotno: boolean) {
            this.form.ItemTypeId.value = item.ItemTypeId;
            this.form.ProductTypeId.value = item.ProductTypeId;
            this.form.CategoryId.value = item.CategoryId.toString();
            this.form.SubCategoryId.value = item.SubCategoryId.toString();
            this.form.StoneColorId.value = item.StoneColorId == null ? "0" : item.StoneColorId.toString();
            this.form.StoneSizeId.value = item.StoneSizeId == null ? "0" : item.StoneSizeId.toString();
            this.form.SieveId.value = item.SieveId == null ? "0" : item.SieveId.toString();
            this.form.QualityId.value = item.QualityId == null ? "0" : item.QualityId.toString();
            this.form.ShapeId.value = item.ShapeId == null ? "0" : item.ShapeId.toString();
            this.form.Rate.value = item.UnitRate == null ? 0 : item.UnitRate;
            //this.form.Weight.value = item.Weight;
            //this.form.Pieces.value = item.Pieces;
            this.form.NewPieces.value = 0;
            this.form.NewWeight.value = 0;
            this.form.LotNo.value = createlotno ? "" : item.LotNo;
            this.form.NewProductId.value = item.ProductId.toString();
            this.setAttributeReadOnly(false);
        }
        protected setAttributeReadOnly(value: boolean) {
            Serenity.EditorUtils.setReadonly(this.form.NewProductId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.CategoryId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.SubCategoryId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.StoneSizeId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.StoneColorId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.QualityId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.SieveId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.StoneSizeId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.ShapeId.element, value);
            Serenity.EditorUtils.setReadonly(this.form.NewProductId.element, value);
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.Details.getItems().length > 0) {
                var detail = this.form.Details.getItems()[0];
                var detailitems = detail.ItemsDetails;
                this.form.DetailItems.setOldItems(detailitems);
            }
        }
        protected validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var items = this.form.DetailItems.getItems();
            if (items.length == 0) {
                q.alert('', 'Items need to be Sorted!', true, 2999);
                returnvalue = false;
                return returnvalue;
            }

            for (var i = 0; i < items.length; i++) {
                delete items[i]["__id"];
            }

            this.form.Details.getItems()[0].ItemsDetails = items;
            return returnvalue;
        }
    }
}